import React from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as queryString from 'query-string';
import Covid19VaccineProvider from './Covid19VaccineProvider';
import { queryParams } from "../../helpers/formatting";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import StatusBanner from '../common/StatusBanner';

class Covid19VaccineScheduleError extends React.Component {

    constructor(props) {
        super(props);
        this.searchModel = null;
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Covid19VaccineScheduleError.ComponentDidMount", new Date(), Tools.getURLPath());
        const {
            location: {
                search = ""
            } = {}
        } = this.props || {};

        this.searchModel = search ? queryString.parse(search) : {};
    }

    render() {
        const { showSlots, providers, providerSearchModel, providerId, selectedSlotTime, scheduleAppointmentError, xid, showCustomError, headerMsg, bodyMsg, retryBtnText } = this.props;
        const providerData = providers && providers.length > 0 && providers.filter(item => item.provider.epicID === providerId);

        let vaccineLocUrl = '/findcare/vaccine';
        let findcareSearchParms = "?" + queryParams({
            location: this.searchModel && this.searchModel.loc ? this.searchModel.loc :
                                        providerSearchModel && providerSearchModel.Location ? providerSearchModel.Location : null,
            visitType: this.searchModel && this.searchModel.visitTypeId ? this.searchModel.visitTypeId :
                                providerSearchModel && providerSearchModel.visitTypeId ? providerSearchModel.visitTypeId : null,
            xid: xid ? xid : null
        });
        vaccineLocUrl = vaccineLocUrl + findcareSearchParms;
       
        return (
            (showCustomError || (scheduleAppointmentError && scheduleAppointmentError.canRetry)) ? <div className="row covid-vaccine-schedule-error">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <div className="col covid-vaccine-schedule-error__img">
                                <span className="svg-nurse" />
                            </div>
                            <div className="col covid-vaccine-schedule-error__body">
                                <div className="row">
                                    <div className="col-12 covid-vaccine-schedule-error__heading">
                                         <h1>{(showCustomError && headerMsg) ? headerMsg : scheduleAppointmentError && scheduleAppointmentError.friendlyMessage ? scheduleAppointmentError.friendlyMessage : "We're sorry, this appointment is no longer available."}</h1>
                                         {(showCustomError && bodyMsg) ? 
                                               <div className="row error-body-msg">
                                                    <div className="col-12">
                                                        <div className="details-icon-prepend">
                                                            <div className="icon-col">
                                                                <span className="icon-info-filled" />
                                                            </div>
                                                            <div className="details-col">{bodyMsg}</div>
                                                        </div>
                                                    </div>
                                                </div> :
                                                 <p>
                                                    Select another appointment time at this location or try a new search.
                                                 </p>}
                                    </div>
                                {(showCustomError && retryBtnText) ?
                                    <div className="col-12">
                                        <Link className="btn btn-primary" to={vaccineLocUrl} onClick={(e) => { logUI("MBHWeb.UI.Covid19VaccineScheduleError.CustomError.TryNewSearch.Clicked", new Date(), Tools.getURLPath()); }}>{retryBtnText}</Link>
                                    </div> : (showSlots && providerData && providerData.length > 0
                                        ? <Covid19VaccineProvider
                                            providerData={providerData[0].provider}
                                            isVaccineSearch
                                            showProviderDetails={false}
                                            slotsNeeded={3}
                                            initiateRetry={this.props.initiateRetry}
                                            selectedSlotTime={selectedSlotTime}
                                            xid={xid}
                                        />
                                        : <div className="col-12">
                                            <Link className="btn btn-primary" to={vaccineLocUrl} onClick={(e) => { logUI("MBHWeb.UI.Covid19VaccineScheduleError.TryNewSearch.Clicked", new Date(), Tools.getURLPath()); }}>TRY A NEW SEARCH</Link>
                                        </div>)
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div> :  <div className="row">
                    <div className="col-12">
                        <StatusBanner bannerMsg={"We're unable to schedule the appointment."} failedStatus>
                            {scheduleAppointmentError && scheduleAppointmentError.friendlyMessage && <span>{scheduleAppointmentError.friendlyMessage} </span>}
                        </StatusBanner>
                    </div>
                </div>
        )
    } 
}

const mapStateToProps = (state, ownProps) => {
    return {
      ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Covid19VaccineScheduleError));